import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTradingViewLine: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="trading-view-line">
      <path
        d="M2 15.8889L7 10.3333L14 17L22 7"
        stroke="currentColor"
        strokeWidth="2"
      />
    </CentralIconBase>
  );
};

export default IconTradingViewLine;
